import { Space, Typography } from '@sravni/react-design-system';

import type { TPreparedVitrinsOffer } from 'shared/types/TVitrinsService';
import { VITRINS_OFFER_CARD_TEXTS } from 'shared/ui/VitrinsOffersCard';

import { PSK_TOOLTIP } from 'entities/vitrins';

export const buildSummary = (offer: TPreparedVitrinsOffer) => {
  const isServer = typeof window === 'undefined';

  return [
    {
      label: offer.psk ? VITRINS_OFFER_CARD_TEXTS.PSK : '',
      value: offer.psk ?? '',
      tooltip:
        offer.psk && !isServer ? (
          <Space
            direction="vertical"
            size={8}
          >
            <Typography.Heading level={5}>{PSK_TOOLTIP.title}</Typography.Heading>
            <Typography.Text size={12}>{PSK_TOOLTIP.content}</Typography.Text>
          </Space>
        ) : null,
    },
    {
      label: offer.rate ? VITRINS_OFFER_CARD_TEXTS.RATE : '',
      value: offer.rate ?? '',
    },
    {
      label: offer.sum ? VITRINS_OFFER_CARD_TEXTS.SUM : '',
      value: offer.sum ?? '',
    },
    {
      label: offer.term ? VITRINS_OFFER_CARD_TEXTS.TERM : '',
      value: offer.term ?? '',
    },
  ].filter(({ label, value }) => Boolean(label || value));
};
